import React from "react";
import SvgFrag from "./../../images/frag-axe.svg"
import ImageFrag1 from "./../../images/A1xF1_TimbreHabitation_Qc.png"
import ImageFrag2 from "./../../images/fragment-manquant.svg"
import ImageFrag3 from "./../../images/A1xF2_03Q_P560-S1-P906.jpg"
import ImageFrag4 from "./../../images/A1xF3_N401024.jpg"
import ImageFrag5 from "./../../images/A1xF4_N028797.jpg"

const openModal = (ev) => {
    console.log('test');
    var target = ev.target;
    if (target.classList.contains('frag--container')){
    } else if (target.parentNode.classList.contains('frag--container')){
        target = target.parentNode;
    } else if (target.parentNode.parentNode.classList.contains('frag--container')){
        target = target.parentNode.parentNode;
    } else if (target.parentNode.parentNode.parentNode.classList.contains('frag--container')){
        target = target.parentNode.parentNode.parentNode;
    }
    target.classList.toggle('show');
}

export default () => (
  <div className="frag--wrapper">
      <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F1</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag1} alt=""/>
                <span>Timbre commémoratif pour le tricentenaire du Canada. Gravure de Elie Timothée Loizeaux, D&#39;après le dessin original de Samuel de Champlain, BAC, 1908 (1609).</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F2</span>
        <div className="frag--modal missing">
            <div className="frag--content">
                <ImageFrag2/>
                <span>L&#39;Habitation après l&#39;incendie de la basse-ville de 1682. Source inconnue, sans date.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F3</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag3} alt=""/>
                <span>Érigée sur l&#39;ancien site de l&#39;Abitation, l&#39;Église Notre Dame des Victoires. Jules Ernest Livernois(att.), Fond Jules Ernest Liversion Ltée, BAnQ, ca 1905.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F4</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag4} alt=""/>
                <span>Une tabagie en face de l&#39;Abitation disparue. Photographe inconnu, Fonds de la Ville de Québec, AVQ, 1973.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F5</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag5} alt=""/>
                <span>Excavations sur l&#39;ancien site de l&#39;Abitation. Photographe inconnu, Fonds de la Ville de Québec, AVQ, 1986.</span>
            </div>
        </div>
     </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/frag-axe1.js